import loadExternalScript from '@/mikan/_shared/lib/utilities/loadExternalScript';

const gptSrcUrl = 'https://www.googletagservices.com/tag/js/gpt.js';

export default async () => {
  if (window.googletag) {
    return;
  }

  await loadExternalScript(gptSrcUrl);
};
